import { ArdoqId } from '@ardoq/api-types';
import { AccessSpec, compileAccessSpecs } from './compileAccessSpecs';
import { PermissionContext } from './types';

export const compileCanDoFn = <ActionKeys extends string>(
  actionAccessSpecs: Record<ActionKeys, AccessSpec | AccessSpec[]>
) => {
  const accessChecks = compileAccessSpecs(actionAccessSpecs);

  /**
   * The function to run to check if a user can perform an action.
   *
   * This will run both:
   * - A privilege check; answering if the user can perform the action in general
   * - A permission check; answering if the user can perform the action on the particular resource
   */
  return function canDo(args: {
    action: ActionKeys;
    permissionContext: PermissionContext;
    resourceId: ArdoqId;
  }) {
    const { action, permissionContext, resourceId } = args;
    const handler = accessChecks[action];
    if (!handler) {
      throw new Error(`Cannot find permission handler for "${action}"`);
    }
    return handler(permissionContext, resourceId);
  };
};
